import * as React from 'react'
import { Column } from '../typings'
import { ReducerProps } from '../reducer'
import { sortListItemStyles as useStyles } from './styles'

import IconButton from '@mui/material/IconButton'
import Card from '@mui/material/Card'
import CloseIcon from '@mui/icons-material/Close'

interface Props extends ReducerProps {
  column: Column
}

export const SortListItemDisabled: React.FC<Props> = (props) => {
  const {
    column: { field, label, disabled },
    dispatch,
  } = props

  const onClick = React.useCallback(() => {
    dispatch({ type: 'toggle', payload: { field, value: false } })
  }, [dispatch, field])

  return (
    <Card sx={{ ...useStyles.root }}>
      {label}
      {!disabled && (
        <IconButton
          onClick={onClick}
          sx={{ ...useStyles.button }}
          size="small"
          data-test-id={`sortListItemDisabledRemoveBtn-${field}`}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    </Card>
  )
}
